export default "skymp5-front/98a93eb6c79b9c5c04c4aa2f05b907c7.png";